export default __webpack_public_path__ + "static/media/10.0b125b99.png";